import type {
  Value,
  Variant
} from "../types/product"


// 找到当前 size 的所有 variants
const findVariants = ({
  item_value_index,
  variants,
  attribute_code
}:{
    item_value_index: number
    variants: Variant[],
    attribute_code: string
}) => {
  const match = variants.filter((variant) => {
    const {
      attributes 
    } = variant || {}


    const attribute = attributes.find((item) => item.code === attribute_code)

    const {
      value_index: variant_value_index 
    } = attribute || {}

    return variant_value_index === item_value_index
  })

  return match
}


export const getInStockSize = ({
  values,
  variants,
  attribute_code
}:{
    values: Value[],
    variants: Variant[],
    attribute_code: string
}) => {

  const instockArray: Value[] = []
  const outofStockArray: Value[] = []

  values.forEach((item) => {
    const {
      value_index: item_value_index 
    } = item || {}


    const match = findVariants({
      item_value_index,
      variants,
      attribute_code
    })

    const allOutOfStock = match.every(item => item.product.stock_status === "OUT_OF_STOCK");
  
    if (allOutOfStock) {
      outofStockArray.push(item)
    } else {
      instockArray.push(item)
    }
  })

  return [...instockArray]
}
